import axios from "../../config/axiosConfig";
import {
  CREATE_WORKER_UPAD, DELETE_WORKER_UPAD,
  GET_WORKER_UPAD,
  WORKER_UPAD_REQUEST,
  WORKER_UPAD_REQUEST_FAILURE,
  UPDATE_WORKER_UPAD
} from "../types/worker-upad-types";

export const getWorkerUpad = () => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: WORKER_UPAD_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id };
      return axios.get("/worker-upad/getAll", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_WORKER_UPAD, payload: response.data });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: WORKER_UPAD_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: WORKER_UPAD_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const createWorkerUpad = (workerUpad) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      dispatch({ type: WORKER_UPAD_REQUEST });
      const newWorkerUpad = {
        ...workerUpad
      };
      return axios.post("/worker-upad/add", newWorkerUpad,
        { params: { userId: auth.user?.id, companyId: auth.company?.id, finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id } }
      ).then((response) => {
        if (response.data) {
          dispatch({ type: CREATE_WORKER_UPAD, payload: response.data });
        } else {
          dispatch({
            type: WORKER_UPAD_REQUEST_FAILURE,
            error: "Worker Attendance Monthly create failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: WORKER_UPAD_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: WORKER_UPAD_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const updateWorkerUpad = (id, data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: WORKER_UPAD_REQUEST });
      const { auth } = getState();
      return axios.put("/worker-upad/update", { id, data },
        { params: {
          userId: auth.user?.id,
          companyId: data.Company_Id || auth.company?.id,
          finyearId: data.Finyear_Id || auth.finyear?.id,
          customerId: data.Customer_Id || auth?.user?.Customer_Id,
        }}
      ).then((response) => {
        if (response.data) {
          dispatch({
            type: UPDATE_WORKER_UPAD,
            payload: { id, data: response.data },
          });
        } else {
          dispatch({
            type: WORKER_UPAD_REQUEST_FAILURE,
            error: "Worker Attendance Monthly update failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: WORKER_UPAD_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: WORKER_UPAD_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const deleteWorkerUpad = (id) => {
  return async (dispatch) => {
    try {
      dispatch({ type: WORKER_UPAD_REQUEST });
      return axios.delete(`/worker-upad/delete/${id}`).then((response) => {
        if (response.data) {
          dispatch({ type: DELETE_WORKER_UPAD, id: id });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: WORKER_UPAD_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: WORKER_UPAD_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};